import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const EnterFullscreenIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 22),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /*#__PURE__*/jsx("g", {
      transform: "translate(-14 -14)",
      children: /*#__PURE__*/jsx("path", {
        d: "M22 35h-7v-7m13-13h7v7m0 6v7h-7M15 22v-7h7"
      })
    })
  });
};

export { EnterFullscreenIcon };
//# sourceMappingURL=fullscreen.enter.js.map
